export const couponStateEnum = [
    {
        stateId: "AVAILABLE",
        stateName: "未使用"
    },
    {
        stateId: "USED",
        stateName: "已使用"
    },
    {
        stateId: "EXPIRED",
        stateName: "已过期"
    },
    {
        stateId: "CANCELLED",
        stateName: "已取消"
    }
]